import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AuthService, UserRoles } from '../../services/auth.service';
import { AGENT_SETUP_TABS, AgentSetupTab, AgentSetupTabKey } from './agent-setup-tabs';

/**
 * KI-Agenten › Verhalten & Fähigkeiten — client level. One menu entry, four
 * tabs (same tab UI as Platzierungen): Learnings, Skills, MCP connectors,
 * Regeln & Grenzen. Each tab is its own URL (/agent-setup/<key>), so links
 * and reloads land on the right tab; switching tabs only changes the
 * parameter, the page is not rebuilt. Skills and MCP are admin/manager only.
 */
@Component({
  selector: 'app-agent-setup',
  templateUrl: './agent-setup.component.html',
  styleUrl: './agent-setup.component.scss',
})
export class AgentSetupComponent implements OnInit, OnDestroy {
  tabs: AgentSetupTab[] = [];
  active: AgentSetupTabKey = 'learnings';
  private sub?: Subscription;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private auth: AuthService
  ) {}

  ngOnInit(): void {
    const role = this.auth.accessTokenPayload$.value?.role;
    const admin = role === UserRoles.Admin || role === UserRoles.Manager || role === UserRoles.SuperAdmin;
    this.tabs = AGENT_SETUP_TABS.filter((t) => (admin || !t.adminOnly) && !t.agentOnly);
    this.sub = this.route.paramMap.subscribe((params) => {
      const wanted = params.get('tab') as AgentSetupTabKey;
      if (this.tabs.some((t) => t.key === wanted)) {
        this.active = wanted;
      } else {
        this.router.navigate(['/agent-setup', this.tabs[0].key], { replaceUrl: true });
      }
    });
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }

  onTabChange(tab: { tabId: string }): void {
    if (tab?.tabId && tab.tabId !== this.active) {
      this.router.navigate(['/agent-setup', tab.tabId], { replaceUrl: true });
    }
  }

  trackTab = (_: number, t: AgentSetupTab) => t.key;
}
